import React from 'react';
import DynamicContent from 'components/NewHome/DynamicContent';
import Table from 'components/NewHome/Table';
import ProductTable from 'components/NewHome/ProductTable';
import useIsMobile from 'utils/hooks/useIsMobile';
import MobileHome from './Mobile';

export default function NewHome() {
  if (useIsMobile()) {
    return <MobileHome />;
  }

  return (
    <div className="dark-outlet-background">
      <DynamicContent />
      <ProductTable />
      <Table />
    </div>
  );
}
